const callApi = async (
  endpoint,
  method = "GET",
  data = null,
  auth_required = true,
  setAlertMessage,
  headers = {
    "Content-Type": "application/json",
  },
  stringify = true
) => {
  var headers = headers
    ? {
        "Content-Type": "application/json",
        ...headers,
      }
    : {};
  if (auth_required) {
    headers["Authorization"] = `Bearer ` + localStorage.getItem("token");
  }

  try {
    const options = {
      method,
      headers: headers,
    };

    if (data) {
      options.body = stringify ? JSON.stringify(data) : data;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API}${endpoint}`,
      options
    );

    if (!response.ok) {
      if (response.status != 401) {
        const errorData = await response.json();
        if (setAlertMessage) {
          setAlertMessage(
            errorData.message ? errorData.message : errorData.title
          );
        }
        return { body: null, success: false, message: errorData.message };
      }
      return { body: null, success: true, message: "" };
    }

    return await response.json();
  } catch (error) {
    if (setAlertMessage) {
      setAlertMessage(error);
    }
    return { body: null, success: false, message: error };
  }
};

export default callApi;
